/**************************************************
 * Nombre:       Seccion_Home
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Portada from "./Componentes/Home_Portada";
import Home_Cabana from "./Componentes/Home_Cabana";
import Home_Servicios from "./Componentes/Home_Servicios";
import Home_Contactos from "./Componentes/Home_Contactos";
import Home_Actividades from "./Componentes/Home_Actividades";
import {APARTADOS} from "../../Constantes";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Seccion_Home = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid id={APARTADOS[0]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', zIndex: 1}}>
                <Home_Portada/>
            </Grid>

            <Grid id={APARTADOS[1]} container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: sCell ? 10 : 12, zIndex: 2}}>
                <Home_Cabana />
            </Grid>

            <Grid  container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1, mt: -10}}>
                <Home_Servicios/>
            </Grid>

            <Grid id={APARTADOS[3]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? 10 : 16}}>
                <Home_Contactos/>
            </Grid>

            <Grid  id={APARTADOS[2]} container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 12}}>
                <Home_Actividades/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Home